// extracted by mini-css-extract-plugin
export default {"news":"news_news__TzwHH","featured":"news_featured__N1b9w","img":"news_img__p7lza","titleFeatured":"news_titleFeatured__WzzLi"};